import TotalSummaryTable from "components/TotalSummaryTable";
import React, { useState } from "react";
import { Button, Col, OffcanvasBody, OffcanvasHeader, Table } from "reactstrap";
import { getSummaryData, toNumberFormat } from "utils/Utils";
import DefaultOffCanvas from "../DefaultOffCanvas";
import styles from "./style.module.scss";
import cx from "classnames";

const PackageCostDetailsOffCanvas = (props) => {
  const { box, className, color = "link", label = "" } = props;
  const [isOpen, setIsOpen] = useState(false);

  const toogleOffCanvas = (e) => {
    setIsOpen(!isOpen);
  }

  const getPackageCost = () => {
    const { boxCost = {} } = box
    let cost = boxCost?.total || 0;
    if (cost) {
      return `$${toNumberFormat(cost)}`;
    } else {
      return " N / D";
    }
  }

  const getCostTableData = (boxCost) => {
    let tableRow = [];
    if (boxCost.data) {
      tableRow = JSON.parse(boxCost.data);
    }
    return tableRow.map(r => {
      return (
        <tr>
          <td>{r.cant}</td>
          <td>{r.description}</td>
          <td className={styles.tablePriceColumn}>{toNumberFormat(r.price)} USD </td>
        </tr>
      )
    });
  }

  return (
    <>
      <Button
        color={color}
        className={className}
        onClick={() => toogleOffCanvas()}
      >
        {label || getPackageCost(box)}
      </Button>
      <DefaultOffCanvas
        direction="end"
        isOpen={isOpen}
        toggle={() => toogleOffCanvas()}
      >
        <OffcanvasHeader toggle={() => toogleOffCanvas()}>
          Costo del Paquete <b>{box.secuencia}</b>
        </OffcanvasHeader>
        <OffcanvasBody>
          {!box.boxCost && (
            <div class="fade alert alert-warning show">
              <h1 class="display-4">Costo no Disponible</h1>
              <p class="lead">
                Actualmente la informacion sobre el costo del paquete no esta disponible ya que el paquete aun esta en transito
              </p>
            </div>
          )}
          {box.boxCost && (
            <>
              <Table>
                <thead>
                  <tr>
                    <th className="col-2"> Cant</th>
                    <th className="col-7"> Description</th>
                    <th className={cx(["col-3", styles.tablePriceColumn])}> Precio</th>
                  </tr>
                </thead>
                <tbody>
                  {getCostTableData(box.boxCost)}
                </tbody>
              </Table>
              <Col
                sm={{
                  offset: 6,
                  size: 6
                }}>
                <TotalSummaryTable data={getSummaryData(box.boxCost)} />
              </Col>
            </>
          )}
        </OffcanvasBody>
      </DefaultOffCanvas>
    </>
  );

}

export default PackageCostDetailsOffCanvas;